export const paymentsList = [
  {
    image: (
      <svg
        width="62"
        height="62"
        viewBox="0 0 62 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M56.8327 30.9994C56.8327 45.2594 45.2594 56.8327 30.9994 56.8327C16.7393 56.8327 5.16602 45.2594 5.16602 30.9994C5.16602 16.7393 16.7393 5.16602 30.9994 5.16602"
          stroke="#737B8B"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.8412 3.79314L47.7105 14.1256L58.043 14.2563"
          stroke="#F2000B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M60.7903 1.37343L47.7113 14.1257"
          stroke="#F2000B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.0179 38.75V21.0735C26.0178 20.6979 26.1246 20.3328 26.3217 20.0357C26.5187 19.7385 26.7947 19.5262 27.1065 19.4319C27.4182 19.3377 27.7479 19.3669 28.0438 19.515C28.3397 19.6631 28.5851 19.9217 28.7414 20.2501L37.1336 37.8749C37.2899 38.2033 37.5353 38.4619 37.8312 38.61C38.1271 38.7581 38.4568 38.7873 38.7685 38.6931C39.0803 38.5988 39.3563 38.3865 39.5533 38.0893C39.7504 37.7922 39.8572 37.4271 39.8571 37.0515V19.375M23.25 25.8333H42.625M23.25 32.2917H42.625"
          stroke="#4DC736"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    title: "Receive Money",
    desc: "Receive payment from anyone",
    tag:"receive"
  },

  {
    image: (
      <svg
        width="62"
        height="62"
        viewBox="0 0 62 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.0179 38.75V21.0735C26.0178 20.6979 26.1246 20.3328 26.3217 20.0357C26.5187 19.7385 26.7947 19.5262 27.1065 19.4319C27.4182 19.3377 27.7479 19.3669 28.0438 19.515C28.3397 19.6631 28.5851 19.9217 28.7414 20.2501L37.1336 37.8749C37.2899 38.2033 37.5353 38.4619 37.8312 38.61C38.1271 38.7581 38.4568 38.7873 38.7685 38.6931C39.0803 38.5988 39.3563 38.3865 39.5533 38.0893C39.7504 37.7922 39.8572 37.4271 39.8571 37.0515V19.375M23.25 25.8333H42.625M23.25 32.2917H42.625"
          stroke="#4DC736"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M56.8327 30.9994C56.8327 45.2594 45.2594 56.8327 30.9994 56.8327C16.7393 56.8327 5.16602 45.2594 5.16602 30.9994C5.16602 16.7393 16.7393 5.16602 30.9994 5.16602"
          stroke="#737B8B"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M60.7083 11.6243V1.29102H50.375"
          stroke="#32D16D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.791 14.2077L60.7077 1.29102"
          stroke="#32D16D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.0179 38.75V21.0735C26.0178 20.6979 26.1246 20.3328 26.3217 20.0357C26.5187 19.7385 26.7947 19.5262 27.1065 19.4319C27.4182 19.3377 27.7479 19.3669 28.0438 19.515C28.3397 19.6631 28.5851 19.9217 28.7414 20.2501L37.1336 37.8749C37.2899 38.2033 37.5353 38.4619 37.8312 38.61C38.1271 38.7581 38.4568 38.7873 38.7685 38.6931C39.0803 38.5988 39.3563 38.3865 39.5533 38.0893C39.7504 37.7922 39.8572 37.4271 39.8571 37.0515V19.375M23.25 25.8333H42.625M23.25 32.2917H42.625"
          stroke="#4DC736"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    title: "Send Money",
    desc: "Receive payment from anyone",
    tag:"send"
  },

  {
    image: (
      <svg
        width="62"
        height="62"
        viewBox="0 0 62 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_475_10393)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.333 12.9165C10.333 10.8611 11.1495 8.88983 12.6029 7.43643C14.0563 5.98302 16.0276 5.1665 18.083 5.1665H43.9163C45.9718 5.1665 47.943 5.98302 49.3964 7.43643C50.8498 8.88983 51.6663 10.8611 51.6663 12.9165V54.2498C51.666 54.7364 51.5283 55.213 51.2691 55.6247C51.0098 56.0365 50.6395 56.3666 50.2009 56.5772C49.7622 56.7877 49.2731 56.8701 48.7896 56.8148C48.3062 56.7596 47.8482 56.5689 47.4684 56.2648L42.6247 52.3898L37.7809 56.2648C37.2847 56.6624 36.6593 56.863 36.0244 56.8282C35.3895 56.7934 34.7897 56.5256 34.3399 56.0763L30.9997 52.736L27.6594 56.0763C27.2099 56.526 26.6104 56.7942 25.9755 56.8295C25.3406 56.8648 24.715 56.6646 24.2184 56.2674L19.3747 52.3898L14.5309 56.2648C14.1511 56.5689 13.6931 56.7596 13.2097 56.8148C12.7263 56.8701 12.2371 56.7877 11.7985 56.5772C11.3598 56.3666 10.9895 56.0365 10.7303 55.6247C10.471 55.213 10.3333 54.7364 10.333 54.2498V12.9165ZM18.083 10.3332C17.3979 10.3332 16.7408 10.6053 16.2563 11.0898C15.7718 11.5743 15.4997 12.2314 15.4997 12.9165V48.8765L17.7601 47.0682C18.2183 46.7013 18.7877 46.5015 19.3747 46.5015C19.9616 46.5015 20.5311 46.7013 20.9893 47.0682L25.6393 50.7882L29.1733 47.2568C29.6577 46.7724 30.3147 46.5004 30.9997 46.5004C31.6847 46.5004 32.3416 46.7724 32.8261 47.2568L36.3575 50.7882L41.0101 47.0682C41.4683 46.7013 42.0377 46.5015 42.6247 46.5015C43.2116 46.5015 43.7811 46.7013 44.2393 47.0682L46.4997 48.8765V12.9165C46.4997 12.2314 46.2275 11.5743 45.743 11.0898C45.2586 10.6053 44.6015 10.3332 43.9163 10.3332H18.083ZM20.6663 23.2498C20.6663 22.5647 20.9385 21.9076 21.423 21.4231C21.9075 20.9387 22.5645 20.6665 23.2497 20.6665H38.7497C39.4348 20.6665 40.0919 20.9387 40.5764 21.4231C41.0608 21.9076 41.333 22.5647 41.333 23.2498C41.333 23.935 41.0608 24.5921 40.5764 25.0765C40.0919 25.561 39.4348 25.8332 38.7497 25.8332H23.2497C22.5645 25.8332 21.9075 25.561 21.423 25.0765C20.9385 24.5921 20.6663 23.935 20.6663 23.2498ZM23.2497 30.9998C22.5645 30.9998 21.9075 31.272 21.423 31.7565C20.9385 32.2409 20.6663 32.898 20.6663 33.5832C20.6663 34.2683 20.9385 34.9254 21.423 35.4099C21.9075 35.8943 22.5645 36.1665 23.2497 36.1665H30.9997C31.6848 36.1665 32.3419 35.8943 32.8264 35.4099C33.3108 34.9254 33.583 34.2683 33.583 33.5832C33.583 32.898 33.3108 32.2409 32.8264 31.7565C32.3419 31.272 31.6848 30.9998 30.9997 30.9998H23.2497Z"
            fill="#737B8B"
          />
        </g>
        <defs>
          <clipPath id="clip0_475_10393">
            <rect width="62" height="62" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    title: "Airtime/Data",
    desc: "Buy airtime and data for all local networks",
    tag:"airtime"
  },

  {
    image: (
      <svg
        width="62"
        height="62"
        viewBox="0 0 62 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M46.5 50.375H15.5C11.2065 50.375 7.75 46.9185 7.75 42.625V23.25C7.75 18.9565 11.2065 15.5 15.5 15.5H46.5C50.7935 15.5 54.25 18.9565 54.25 23.25V42.625C54.25 46.9185 50.7935 50.375 46.5 50.375Z"
          stroke="#737B8B"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.25 58.125H38.75"
          stroke="#737B8B"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M31 15.5L42.625 3.875"
          stroke="#737B8B"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M31 15.5L19.375 3.875"
          stroke="#737B8B"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    title: "Cable TV",
    desc: "Recharge your cable TV",
    tag:"cableTv"
  },

  {
    image: (
      <svg
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_2307_41793)">
          <rect
            x="4.25"
            y="0.25"
            width="61.5"
            height="61.5"
            rx="7.75"
            stroke="#ADB7BE"
            strokeWidth="0.5"
          />
        </g>
        <path
          d="M28.94 43C28.5581 43 28.1918 42.8483 27.9218 42.5782C27.6517 42.3082 27.5 41.9419 27.5 41.56V24.656C27.5 23.861 28.145 23.216 28.94 23.216H30.646C30.7 23.216 30.752 23.229 30.797 23.252L30.795 23.251V19.168C30.795 19.075 30.87 19 30.963 19H36.983C37.076 19 37.151 19.075 37.151 19.168V23.227C37.1772 23.2205 37.204 23.2171 37.231 23.217H38.746C39.541 23.217 40.186 23.862 40.186 24.657V28.688C40.2311 28.666 40.2808 28.6547 40.331 28.655H41.088C41.274 28.655 41.425 28.806 41.425 28.992V37.764C41.425 37.8534 41.3895 37.9391 41.3263 38.0023C41.2631 38.0655 41.1774 38.101 41.088 38.101H40.331C40.28 38.1012 40.2297 38.0895 40.184 38.067L40.186 38.068V41.56C40.186 41.9419 40.0343 42.3082 39.7642 42.5782C39.4942 42.8483 39.1279 43 38.746 43H28.94ZM36.264 39.769V40.903C36.2643 40.9477 36.2822 40.9906 36.3138 41.0222C36.3454 41.0538 36.3883 41.0717 36.433 41.072H37.767C37.8117 41.0717 37.8546 41.0538 37.8862 41.0222C37.9178 40.9906 37.9357 40.9477 37.936 40.903V39.769C37.9357 39.7244 37.9178 39.6816 37.8861 39.6501C37.8545 39.6187 37.8116 39.601 37.767 39.601H36.431C36.3864 39.6013 36.3437 39.619 36.3121 39.6504C36.2805 39.6819 36.2625 39.7244 36.262 39.769H36.264ZM33.108 39.769V40.903C33.1083 40.9477 33.1262 40.9906 33.1578 41.0222C33.1894 41.0538 33.2323 41.0717 33.277 41.072H34.61C34.6547 41.0717 34.6976 41.0538 34.7292 41.0222C34.7608 40.9906 34.7787 40.9477 34.779 40.903V39.769C34.7787 39.7244 34.7608 39.6816 34.7291 39.6501C34.6975 39.6187 34.6546 39.601 34.61 39.601H33.276C33.2314 39.6013 33.1887 39.619 33.1571 39.6504C33.1255 39.6819 33.1085 39.7244 33.108 39.769ZM29.952 39.769V40.904C29.952 40.997 30.027 41.072 30.12 41.072H31.454C31.4987 41.0717 31.5416 41.0538 31.5732 41.0222C31.6048 40.9906 31.6227 40.9477 31.623 40.903V39.769C31.6227 39.7244 31.6048 39.6816 31.5731 39.6501C31.5415 39.6187 31.4986 39.601 31.454 39.601H30.12C30.0754 39.601 30.0327 39.6187 30.0012 39.6502C29.9697 39.6817 29.952 39.7244 29.952 39.769ZM36.263 37.198V38.332C36.2633 38.3767 36.2812 38.4196 36.3128 38.4512C36.3444 38.4828 36.3873 38.5007 36.432 38.501H37.766C37.8107 38.5007 37.8536 38.4828 37.8852 38.4512C37.9168 38.4196 37.9347 38.3767 37.935 38.332V37.197C37.935 37.1524 37.9173 37.1097 37.8858 37.0782C37.8543 37.0467 37.8116 37.029 37.767 37.029H36.43C36.3854 37.029 36.3427 37.0467 36.3112 37.0782C36.2797 37.1097 36.262 37.1524 36.262 37.197L36.263 37.198ZM33.107 37.198V38.332C33.1073 38.3767 33.1252 38.4196 33.1568 38.4512C33.1884 38.4828 33.2313 38.5007 33.276 38.501H34.61C34.6547 38.5007 34.6976 38.4828 34.7292 38.4512C34.7608 38.4196 34.7787 38.3767 34.779 38.332V37.197C34.779 37.1524 34.7613 37.1097 34.7298 37.0782C34.6983 37.0467 34.6556 37.029 34.611 37.029H33.275C33.2304 37.029 33.1877 37.0467 33.1562 37.0782C33.1247 37.1097 33.107 37.1534 33.107 37.198ZM29.951 37.198V38.333C29.951 38.426 30.026 38.501 30.119 38.501H31.453C31.4977 38.5007 31.5406 38.4828 31.5722 38.4512C31.6038 38.4196 31.6217 38.3767 31.622 38.332V37.197C31.622 37.1524 31.6043 37.1097 31.5728 37.0782C31.5413 37.0467 31.4986 37.029 31.454 37.029H30.119C30.0744 37.029 30.0317 37.0467 30.0002 37.0782C29.9687 37.1097 29.951 37.1534 29.951 37.198ZM36.262 34.626V35.761C36.262 35.854 36.337 35.929 36.43 35.929H37.766C37.8106 35.929 37.8533 35.9113 37.8848 35.8798C37.9163 35.8483 37.934 35.8056 37.934 35.761V34.626C37.9337 34.5814 37.9158 34.5386 37.8841 34.5071C37.8525 34.4757 37.8096 34.458 37.765 34.458H36.431C36.3864 34.4583 36.3437 34.476 36.3121 34.5074C36.2805 34.5389 36.2625 34.5814 36.262 34.626ZM33.106 34.626V35.761C33.106 35.854 33.181 35.929 33.274 35.929H34.61C34.6546 35.929 34.6973 35.9113 34.7288 35.8798C34.7603 35.8483 34.778 35.8056 34.778 35.761V34.626C34.7777 34.5814 34.7598 34.5386 34.7281 34.5071C34.6965 34.4757 34.6536 34.458 34.609 34.458H33.275C33.2304 34.4583 33.1877 34.476 33.1561 34.5074C33.1245 34.5389 33.1065 34.5814 33.106 34.626ZM29.95 34.626V35.761C29.95 35.854 30.025 35.929 30.118 35.929H31.454C31.4986 35.929 31.5413 35.9113 31.5728 35.8798C31.6043 35.8483 31.622 35.8056 31.622 35.761V34.626C31.6217 34.5814 31.6038 34.5386 31.5721 34.5071C31.5405 34.4757 31.4976 34.458 31.453 34.458H30.119C30.0744 34.458 30.0317 34.4757 30.0002 34.5072C29.9687 34.5387 29.95 34.5814 29.95 34.626ZM29.74 27.913V32.825C29.74 32.918 29.815 32.993 29.908 32.993H37.67C37.7146 32.993 37.7573 32.9753 37.7888 32.9438C37.8203 32.9123 37.838 32.8696 37.838 32.825V27.913C37.8377 27.8683 37.8198 27.8254 37.7882 27.7938C37.7566 27.7622 37.7137 27.7443 37.669 27.744H29.909C29.8643 27.7443 29.8214 27.7622 29.7898 27.7938C29.7582 27.8254 29.7403 27.8683 29.74 27.913ZM29.236 25.231V26.421C29.236 26.7 29.462 26.926 29.741 26.926H38.14C38.2739 26.926 38.4024 26.8728 38.4971 26.7781C38.5918 26.6834 38.645 26.5549 38.645 26.421V25.231C38.645 25.0971 38.5918 24.9686 38.4971 24.8739C38.4024 24.7792 38.2739 24.726 38.14 24.726H37.15V25.736H37.638V25.914H30.246V25.736H30.567C30.6481 25.736 30.728 25.7164 30.8 25.679L30.797 25.68V24.782C30.7256 24.745 30.6464 24.7258 30.566 24.726H29.739C29.6052 24.7263 29.477 24.7796 29.3826 24.8743C29.2881 24.9689 29.236 25.0972 29.236 25.231Z"
          fill="#292D32"
        />
        <defs>
          <filter
            id="filter0_d_2307_41793"
            x="0"
            y="0"
            width="70"
            height="70"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2307_41793"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2307_41793"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    ),
    title: "Request Terminals",
    desc: "Request for Mongoro Terminals",
    tag:"pos"
  },

  {
    image: (
      <svg
        width="42"
        height="52"
        viewBox="0 0 42 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.333008 7.9165C0.333008 5.86108 1.14952 3.88983 2.60293 2.43643C4.05634 0.98302 6.02758 0.166504 8.08301 0.166504H33.9163C35.9718 0.166504 37.943 0.98302 39.3964 2.43643C40.8498 3.88983 41.6663 5.86108 41.6663 7.9165V49.2498C41.666 49.7364 41.5283 50.213 41.2691 50.6247C41.0098 51.0365 40.6395 51.3666 40.2009 51.5772C39.7622 51.7877 39.2731 51.8701 38.7896 51.8148C38.3062 51.7596 37.8482 51.5689 37.4684 51.2648L32.6247 47.3898L27.7809 51.2648C27.2847 51.6624 26.6593 51.863 26.0244 51.8282C25.3895 51.7934 24.7897 51.5256 24.3399 51.0763L20.9997 47.736L17.6594 51.0763C17.2099 51.526 16.6104 51.7942 15.9755 51.8295C15.3406 51.8648 14.715 51.6646 14.2184 51.2674L9.37467 47.3898L4.53092 51.2648C4.1511 51.5689 3.69312 51.7596 3.2097 51.8148C2.72629 51.8701 2.2371 51.7877 1.79845 51.5772C1.35981 51.3666 0.989538 51.0365 0.730279 50.6247C0.47102 50.213 0.333312 49.7364 0.333008 49.2498V7.9165ZM8.08301 5.33317C7.39786 5.33317 6.74078 5.60534 6.25632 6.08981C5.77185 6.57428 5.49967 7.23136 5.49967 7.9165V43.8765L7.76009 42.0682C8.21828 41.7013 8.78773 41.5015 9.37467 41.5015C9.96162 41.5015 10.5311 41.7013 10.9893 42.0682L15.6393 45.7882L19.1733 42.2568C19.6577 41.7724 20.3147 41.5004 20.9997 41.5004C21.6847 41.5004 22.3416 41.7724 22.8261 42.2568L26.3575 45.7882L31.0101 42.0682C31.4683 41.7013 32.0377 41.5015 32.6247 41.5015C33.2116 41.5015 33.7811 41.7013 34.2393 42.0682L36.4997 43.8765V7.9165C36.4997 7.23136 36.2275 6.57428 35.743 6.08981C35.2586 5.60534 34.6015 5.33317 33.9163 5.33317H8.08301ZM10.6663 18.2498C10.6663 17.5647 10.9385 16.9076 11.423 16.4231C11.9075 15.9387 12.5645 15.6665 13.2497 15.6665H28.7497C29.4348 15.6665 30.0919 15.9387 30.5764 16.4231C31.0608 16.9076 31.333 17.5647 31.333 18.2498C31.333 18.935 31.0608 19.5921 30.5764 20.0765C30.0919 20.561 29.4348 20.8332 28.7497 20.8332H13.2497C12.5645 20.8332 11.9075 20.561 11.423 20.0765C10.9385 19.5921 10.6663 18.935 10.6663 18.2498ZM13.2497 25.9998C12.5645 25.9998 11.9075 26.272 11.423 26.7565C10.9385 27.2409 10.6663 27.898 10.6663 28.5832C10.6663 29.2683 10.9385 29.9254 11.423 30.4099C11.9075 30.8943 12.5645 31.1665 13.2497 31.1665H20.9997C21.6848 31.1665 22.3419 30.8943 22.8264 30.4099C23.3108 29.9254 23.583 29.2683 23.583 28.5832C23.583 27.898 23.3108 27.2409 22.8264 26.7565C22.3419 26.272 21.6848 25.9998 20.9997 25.9998H13.2497Z"
          fill="#737B8B"
        />
      </svg>
    ),
    title: "Examination",
    desc: "Get your E-pins and result checker",
    tag:"examination"
  },

  {
    image: (
      <svg
        width="52"
        height="50"
        viewBox="0 0 52 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M33.7503 20.8332C33.7503 19.4123 34.9128 18.2498 36.3337 18.2498C37.7545 18.2498 38.917 19.4123 38.917 20.8332C38.917 22.254 37.7545 23.4165 36.3337 23.4165C34.9128 23.4165 33.7503 22.254 33.7503 20.8332ZM15.667 18.2498H28.5837V13.0832H15.667V18.2498ZM51.8337 14.3748V32.3807L44.5487 34.809L40.2087 49.2498H26.0003V44.0832H20.8337V49.2498H6.62533C6.62533 49.2498 0.166992 27.3948 0.166992 19.5415C0.166992 11.6882 6.52199 5.33317 14.3753 5.33317H27.292C29.6428 2.20734 33.3887 0.166504 37.6253 0.166504C38.2637 0.16664 38.8922 0.324711 39.4547 0.626629C40.0172 0.928548 40.4962 1.36494 40.8492 1.8969C41.2021 2.42887 41.418 3.03988 41.4775 3.6755C41.537 4.31112 41.4384 4.95159 41.1903 5.53984C40.8287 6.41817 40.5187 7.42567 40.3637 8.51067L46.2278 14.3748H51.8337ZM46.667 19.5415H44.0837L35.042 10.4998C35.042 8.82067 35.2745 7.16734 35.7137 5.56567C33.2078 6.2115 31.167 8.0715 30.3145 10.4998H14.3753C9.38949 10.4998 5.33366 14.5557 5.33366 19.5415C5.33366 24.3982 8.48533 36.7207 10.5262 44.0832H15.667V38.9165H31.167V44.0832H36.3595L40.3637 30.779L46.667 28.6607V19.5415Z"
          fill="#737B8B"
        />
      </svg>
    ),
    title: "Saving",
    desc: "Save up for the raining days",
    tag:"savings"
  },
];
